import { getDeployEnvArea } from "@ti/max/lib/utils";
import { SUB_APP_NAME } from "./subApps";
import { ENV_AREA } from "./baseUrl";

/**
 * 获取子应用路径
 * @param subApp 子应用名称
 * @param path 子应用内部路径
 */
export const getMicroAppPath = (subApp: SUB_APP_NAME, path: string) => {
  return `/${subApp}${path}`;
};

/**
 * 获取环境区域
 * @param env 环境
 * @param area 区域
 */
export const getEnvArea = (env?: string, area?: string) => {
  let envArea = getDeployEnvArea();
  if (env && area) {
    envArea = `${env}_${area}`;
  }
  return envArea as ENV_AREA;
};
